import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';

import './App.scss';

import Loading from './components/Loading/Loading';
const CheckAuth = React.lazy(() => import('./components/CheckAuth/CheckAuth'));
const Login = React.lazy(() => import('./pages/Login/Login'));
const DefaultLayout = React.lazy(() => import('./containers/Layouts/DefaultLayout'));

const App = (props) => {
  return (
    <ConnectedRouter history={props.history}>
      <React.Suspense fallback={<Loading />}>
        <CheckAuth>
          <Switch>
            <Route exact path="/login" render={(props) => <Login {...props} />} />
            <Route path="/" render={(props) => <DefaultLayout {...props} />} />
          </Switch>
        </CheckAuth>
      </React.Suspense>
    </ConnectedRouter>
  );
};

App.propTypes = {
  history: PropTypes.object,
};

export default App;
